export default "__VITE_ASSET__bbb94050__"